import { RESET_APP } from "./rootActions";
import XsrfToken from "../services/XsrfToken";

export const SET_IN_PROGRESS = "SET_IN_PROGRESS";
export const SET_IN_PROGRESS_FOR_COMPONENT = "SET_IN_PROGRESS_FOR_COMPONENT";
export const SET_LAST_REQUESTED_TIME = "SET_LAST_REQUESTED_TIME";
export const SET_XSRF_TOKEN = "SET_XSRF_TOKEN";
export const SET_LAST_INTERACTION_TIME = "SET_LAST_INTERACTION_TIME";
export const SET_SYSTEM_UNAVAILABLE = "SET_SYSTEM_UNAVAILABLE";
export const SET_VERSION_INCOMPATIBLE = "SET_VERSION_INCOMPATIBLE";
export const SET_LOGGED_OUT = "SET_LOGGED_OUT";

export function setInProgress(value) {
  return (dispatch, getState) => {
    let state = getState();
    if (
      state &&
      state.networkStateReducer &&
      state.networkStateReducer.inProgress !== value
    ) {
      dispatch({ type: SET_IN_PROGRESS, payload: value });
    }
  };
}

export function setInProgressForComponent(value) {
  return (dispatch, getState) => {
    let state = getState();
    if (
      state &&
      state.networkStateReducer &&
      state.networkStateReducer.inProgressForComponent !== value
    ) {
      dispatch({ type: SET_IN_PROGRESS_FOR_COMPONENT, payload: value });
    }
  };
}

export function setTimedOut() {
  return (dispatch, getState) => {
    let state = getState();
    if (state && state.accountReducer && state.accountReducer.isLoggedIn) {
      dispatch({ type: RESET_APP, payload: { isTimedOut: true } });
    }
  };
}

export function setLoggedOut() {
  return { type: SET_LOGGED_OUT, payload: true };
}

export function setLastRequestedTime(time) {
  return {
    type: SET_LAST_REQUESTED_TIME,
    payload: time
  };
}

export function setLastInteractionTime(time) {
  return {
    type: SET_LAST_INTERACTION_TIME,
    payload: time
  };
}

export function setSystemUnavailable(isUnavailable) {
  return { type: RESET_APP, payload: { systemUnavailable: isUnavailable } };
}

export function setVersionIncompatible() {
  return { type: SET_VERSION_INCOMPATIBLE, payload: true };
}

export function validateXSRFToken() {
  let token = XsrfToken.retrieveToken();
  return (dispatch, getState) => {
    let { networkStateReducer } = getState();
    if (!networkStateReducer.xsrfToken && token) {
      dispatch({ type: SET_XSRF_TOKEN, payload: token });
      return token;
    }
    if (networkStateReducer.xsrfToken !== token) {
      dispatch({ type: RESET_APP, payload: { isTimedOut: true } });
      return null;
    }
    return token;
  };
}

export function setXSRFToken(token) {
  return dispatch => {
    XsrfToken.storeToken(token);
    dispatch({ type: SET_XSRF_TOKEN, payload: token });
  };
}
